import { NgModule } from '@angular/core';
import { FiMediaBankService } from '@fi-shared/media-bank/media-bank.service';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { MediaBankHelperService } from '@fi-shared/media-bank/media-bank-helper.service';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { FileSizeModule } from '@fi-shared/media-bank/file-size/file-size.module';
import { FiMediaBankDownloadDialogModule } from '@fi-shared/media-bank/fi-media-bank-download-dialog/fi-media-bank-download-dialog.module';

@NgModule({
    imports: [FiVimeoModule, FileSizeModule, FiMediaBankDownloadDialogModule],
    providers: [FiMediaBankService, MediaBankHelperService, FiMediaStorageService],
    exports: [FiVimeoModule, FileSizeModule],
})
export class FiMediaBankSharedModule {}
